export default __webpack_public_path__ + "static/media/bg7.32c7eec6.jpg";